export class filtersSortService {
  constructor() {
    this.advFilterString = ''
    this.orderString = ''
  }

  orderBy(info, filterString) {
    if (info.columnName === '') return filterString
    this.advFilterString = filterString
    //info  = orderInfo {
    // columnName:string
    // orderbool:boolean
    // }
    this.orderString = ''

    if (this.advFilterString) {
      if (info.orderbool === false) {
        this.orderString = `&orderby=${info.columnName.toLowerCase()} asc`
      } else {
        this.orderString = `&orderby=${info.columnName.toLowerCase()} desc`
      }
      return this.advFilterString.concat(this.orderString)
    }

    if (this.filterString) {
      if (info.orderbool === false) {
        this.orderString = `&orderby=${info.columnName.toLowerCase()} asc`
      } else {
        this.orderString = `&orderby=${info.columnName.toLowerCase()} desc`
      }
      return this.filterString.concat(this.orderString)
    }

    if (this.orderString === '' || this.orderString === undefined) {
      if (info.orderbool === false) {
        this.orderString = `&orderby=${info.columnName.toLowerCase()} asc`
      } else {
        this.orderString = `&orderby=${info.columnName.toLowerCase()} desc`
      }
    }
    return this.orderString
  }

  advancedSearch(arg, bol, FILTER) {
    //arg = metaPair[{
    // name:string
    // type:string
    // operation:string
    // value:string
    // }]
    this.advFilterString = ''

    if (bol === false) {
      this.advFilterString = ''
      return this.advFilterString
    }

    arg.forEach((elem, i) => {
      if (i === 0) {
        if (elem.operation === 'Contains') {
          // this.advFilterString = `&filter=${elem.name} eq '%${elem.value}%'`
          this.advFilterString = `&filter= contains(${elem.name},'${encodeURIComponent(elem.value)}')`
        }
        if (elem.operation === "Equals") {
          if (elem.type === "int32" || elem.type === "boolean") {
            this.advFilterString = `&filter=${elem.name} eq ${encodeURIComponent(elem.value)}`
          } else {
            this.advFilterString = `&filter=${elem.name} eq '${encodeURIComponent(elem.value)}'`
          }
        }
        if (elem.operation === "Greater") {
          this.advFilterString = `&filter=${elem.name} gt ${elem.value}`
        }
        if (elem.operation === "GreaterThanOrEqual") {
          this.advFilterString = `&filter=${elem.name} ge ${elem.value}`
        }
        if (elem.operation === "LessThanOrEqual") {
          this.advFilterString = `&filter=${elem.name} le ${elem.value}`
        }
        return
      }
      if (elem.operation === "Contains") {
        // this.advFilterString = this.advFilterString.concat(` and ${elem.name} eq '%${elem.value}%'`)

        this.advFilterString = this.advFilterString.concat(` and contains(${elem.name}, '${encodeURIComponent(elem.value)}')`)
      }
      if (elem.operation === "Equals") {
        if (elem.type === "int32" || elem.type === "boolean") {
          this.advFilterString = this.advFilterString.concat(` and ${elem.name} eq ${encodeURIComponent(elem.value)}`)
        } else {
          this.advFilterString = this.advFilterString.concat(` and ${elem.name} eq '${encodeURIComponent(elem.value)}'`)
        }
      }
      if (elem.operation === "Greater") {
        this.advFilterString = this.advFilterString.concat(` and ${elem.name} gt ${elem.value}`)
      }
      if (elem.operation === "GreaterThanOrEqual") {
        this.advFilterString = this.advFilterString.concat(` and ${elem.name} ge ${elem.value}`)
      }
      if (elem.operation === "LessThanOrEqual") {
        this.advFilterString = this.advFilterString.concat(` and ${elem.name} le ${elem.value}`)
      }
    })
    if (FILTER) {
      this.advFilterString.concat(FILTER)
    }
    return this.advFilterString
  }

  search(arg, metadados, types) {
    this.filterString = ''
    if (arg === '') {
      return ''
    }
    for (let index = 0; index < metadados.length; index++) {
      if (this.filterString === '' || this.filterString === undefined) {
        if (types[index] !== "int32") {
          this.filterString = `&filter=contains(${metadados[index]}, '${arg}')`
          continue
        } else {
          continue
        }
      } else {
        if (types[index] !== "int32") {
          this.filterString = this.filterString.concat(` or contains(${metadados[index]}, '${arg}')`)
        }
      }
    }
    return this.filterString
  }

  pagination(page, pageSize, FILTER) {
    let pageString = `?page=${page}&pagesize=${pageSize}`
    if (FILTER) pageString.concat(`&filter=${FILTER}`)
    return pageString
  }


  queryBuilder(page, pageSize, order, filters, FILTER) {
    let finalString = ''

    finalString = finalString.concat(`?page=${page}&pagesize=${pageSize}`)

    if (order && order.columnName !== '') {
      if (order.orderbool === false) {
        finalString = finalString.concat(`&orderby=${order.columnName.toLowerCase()} asc`)
      } else {
        finalString = finalString.concat(`&orderby=${order.columnName.toLowerCase()} desc`)
      }
    }
    if (filters && filters.length) {
      filters.forEach((elem, i) => {
        if (i === 0) {
          finalString = finalString.concat('&filter=')
        } else {
          finalString = finalString.concat(' and ')
        }
        if (elem.operation === 'Contains') {
          // finalString = finalString.concat(`${elem.name} eq '$${elem.value}$'`)

          finalString = finalString.concat(` contains(${elem.name}, '${encodeURIComponent(elem.value)}')`)
        }
        if (elem.operation === "Equals") {
          if (elem.type === "int32" || elem.type === "boolean") {
            finalString = finalString.concat(`${elem.name} eq ${encodeURIComponent(elem.value)}`)
          } else {
            finalString = finalString.concat(`${elem.name} eq '${encodeURIComponent(elem.value)}'`)
          }
        }
        if (elem.operation === "Greater") {
          finalString = finalString.concat(`${elem.name} gt ${elem.value}`)
        }
        if (elem.operation === "GreaterThanOrEqual") {
          finalString = finalString.concat(`${elem.name} ge ${elem.value}`)
        }
        if (elem.operation === "LessThanOrEqual") {
          finalString = finalString.concat(`${elem.name} le ${elem.value}`)
        }
      })
      if (FILTER) {
        if (filters.length) {
          finalString = finalString.concat(` and ${FILTER}`)
        } else {
          finalString = finalString.concat(`${FILTER}`)
        }
      }
    } else {
      if (FILTER) {
        finalString = finalString.concat(`&filter=${FILTER}`)
      }
    }
    return finalString
  }

}

